/**
 * =====================================
 * File: PublicPage.js
 * Page: /about, /join, /contact
 * Purpose: Creates the outline of a page that displays text
 *  info on publicly accessible pages
 * Author: Noah Fultz
 * Date: 2026-06-13
 * =====================================
 */


import { PageTitle, PageCard } from '../../components';

import { useState, useEffect } from 'react';

import './PublicPage.css'


function PublicPage({ pagename = 'about' }) {
	// Create variables to store/update the page sections
	const [pageTitle, setPageTitle] = useState('');
	const [pageSections, setPageSections] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	// Gather the body text of each of the page's sections
	useEffect(() => {
		const gatherSections = async () => {
			setIsLoading(true);
			try {
				// Request the page text for the about page
				const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/pagetext/${pagename}`);
				// Process the response
				if (!res.ok) console.log(await res.text());
				else setPageSections(await res.json());
			} catch (error) {
				console.error('Error fetching page content:', error);
			} finally {
				setIsLoading(false);
			}
		}

		gatherSections();
	}, [pagename]);

	// Update the page's title
	useEffect(() => {
		if (pageSections.length === 0) return;

		if (pageSections[0].title === 'ABOUT' ||
			pageSections[0].title === 'JOIN' ||
			pageSections[0].title === 'CONTACT')
			setPageTitle(`${pageSections[0].title} US`);
		else setPageTitle(pageSections[0].title);
	}, [pageSections])


	return (
		<main aria-busy={isLoading}>
			{isLoading && (
				<p className='publicpage-bodytext' role='status' aria-live='polite'>
					Loading page...
				</p>
			)}

			{/* Displays all page sections as returned from the API */}
			{!isLoading && pageSections.length > 0 && (
				<article>
					<PageTitle>{ pageTitle }</PageTitle>

					{pageSections.map(sect => (
						<div key={sect.section}>
							<PageCard header={sect.section !== 'MAIN' ? sect.section : null}>
								<p className='publicpage-bodytext'
									dangerouslySetInnerHTML={{
										__html: sect.body
									}}
								/>
							</PageCard>
							<div className='publicpage-spacer' />
						</div>
					))}
				</article>
			)}
		</main>
	)
}


export default PublicPage;